<div id="uiHeaderEyebrow" class="mt-smd">
  <ng-container *ngTemplateOutlet="headerTemplate; context: { title: title | translate, subTitle: subTitle | translate }"></ng-container>
</div>

<ng-template #headerTemplate let-title="title" let-subTitle="subTitle">
  <p *ngIf="title" text-medium-regular  class="mb-xs" color="var(--secondary-text)">{{ title }}</p>
  <typography-legacy *ngIf="subTitle" title-medium>{{ subTitle }}</typography-legacy>
</ng-template>
